var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tula-footer"},[_c('Footer',{attrs:{"copyright":_vm.copyright,"sections":[],"socials":_vm.socials,"logo":null,"mobileApp":null,"compact":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }